import { colors } from '../styles/colors';

type ChevronIconProps = {
  color?: string;
  size?: string;
  rotate?: string;
}

export const ChevronIcon = ({ size = '14', color = colors.White, rotate }: ChevronIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      rotate,
    }}
  >
    <path d="M8.75 11L5.25 7.5L8.75 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
